import { isNaN, isFinite } from 'underscore';

export const isNumeric = value => !isNaN(parseFloat(value)) && isFinite(value);

export const windowIsUndefined = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);
